import Vue from 'vue';
<template>
  <p>
    <strong>{{ totalResults }} result{{ totalResults > 1 ? 's' : '' }}</strong>
    found<template v-if="searchTerm"> for "{{ searchTerm }}"</template>
  </p>
</template>

<script>
export default {
  name: 'ResultsCount',
  props: {
    totalResults: {
      type: Number,
      default: 0,
    },
    filterParamaters: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    searchTerm() {
      return this.filterParamaters?.query;
    },
  },
};
</script>

<style></style>
